import get from 'lodash.get';
import getStore from './index';
import { useConfig } from './reducers/config';

/**
 * @deprecated This should only be used for existing class components.  Opt for functional components and the
 * useDeviceType hook, instead.
 */
export function getDeviceType() {
  const state = getStore().getState();
  return get(state, 'config.deviceType', 'tablet');
}

export const useDeviceType = (): string => {
  const { deviceType = 'tablet' } = useConfig();

  return deviceType;
};
